import { Modal, Text } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { timeOutIdleUserMinutes } from '../../../utils/timeoutConstants';

const events = ['mousemove', 'mousedown', 'keypress'];

export function IdleUserModalNotLoggedIn() {
    const [showModal, setShowModal] = useState(false);

    let idleUserTimeout: number;

    useEffect(() => {
        for (const event of events) {
            window.addEventListener(event, resetTimeout);
        }

        idleUserTimeout = window.setTimeout(() => setShowModal(true), timeOutIdleUserMinutes * 60 * 1000);

        return () => {
            for (const event of events) {
                window.removeEventListener(event, resetTimeout);
            }

            window.clearTimeout(idleUserTimeout);
        };
    }, []);

    function resetTimeout() {
        if (idleUserTimeout) {
            window.clearTimeout(idleUserTimeout);
        }

        idleUserTimeout = window.setTimeout(() => setShowModal(true), timeOutIdleUserMinutes * 60 * 1000);
    }

    return (
        <Modal
            isOpen={showModal}
            onClose={() => undefined}
            size="small"
        >
            <Modal.Header>Je sessie is verlopen</Modal.Header>
            <Modal.Body>
                <Text>
                    Je bent 15 minuten niet actief geweest. Start het proces opnieuw vanuit de e-mail die je van Ksyos
                    hebt ontvangen. En log daarna in.
                </Text>
            </Modal.Body>
            <Modal.Footer />
        </Modal>
    );
}
